import { lazy, Suspense } from "react";
import { Routes as RRRoutes, Route, Navigate } from "react-router-dom";
import { ProtectedLayout, PublicLayout } from "@/components/ui/Layout";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

const LoginPage = lazy(() =>
  import("@/pages/Login").then((m) => ({ default: m.LoginPage })),
);
const DashboardPage = lazy(() =>
  import("@/pages/Dashboard").then((m) => ({ default: m.DashboardPage })),
);
const ClientsPage = lazy(() =>
  import("@/pages/Clients").then((m) => ({ default: m.ClientsPage })),
);
const ServicesPage = lazy(() =>
  import("@/pages/Services").then((m) => ({ default: m.ServicesPage })),
);
const InvoicesPage = lazy(() =>
  import("@/pages/Invoices").then((m) => ({ default: m.InvoicesPage })),
);
const InvoiceNewPage = lazy(() =>
  import("@/pages/InvoiceNew").then((m) => ({ default: m.InvoiceNewPage })),
);
const PurchasesPage = lazy(() =>
  import("@/pages/Purchases").then((m) => ({ default: m.PurchasesPage })),
);
const InvoiceDetailPage = lazy(() =>
  import("@/pages/InvoiceDetail").then((m) => ({
    default: m.InvoiceDetailPage,
  })),
);
const SettingsPage = lazy(() =>
  import("@/pages/Settings").then((m) => ({ default: m.SettingsPage })),
);
const ProfilePage = lazy(() =>
  import("@/pages/Profile").then((m) => ({ default: m.ProfilePage })),
);
const AuthCallbackPage = lazy(() =>
  import("@/pages/AuthCallback").then((m) => ({ default: m.AuthCallbackPage })),
);
const DevComponentsPage = lazy(() =>
  import("@/pages/DevComponents").then((m) => ({
    default: m.DevComponentsPage,
  })),
);
const DevPdfPreviewPage = lazy(() =>
  import("@/pages/DevPdfPreview").then((m) => ({
    default: m.DevPdfPreviewPage,
  })),
);

function PageFallback() {
  return (
    <div className="min-h-[50vh] grid place-items-center">
      <LoadingSpinner size={24} />
    </div>
  );
}

export function Routes() {
  return (
    <Suspense fallback={<PageFallback />}>
      <RRRoutes>
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route element={<PublicLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dev/components" element={<DevComponentsPage />} />
          <Route path="/dev/pdf-preview" element={<DevPdfPreviewPage />} />
        </Route>
        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/purchases" element={<PurchasesPage />} />
          <Route path="/invoices/new" element={<InvoiceNewPage />} />
          <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
          <Route path="/invoices/:id/edit" element={<InvoiceNewPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </RRRoutes>
    </Suspense>
  );
}
